import TurndownService from 'turndown';
import { IM_MSG_TYPE } from '@/common/constants/IM.ts';
import { calcUserName } from '_lib/CalcUserInfo';
import { fontSizeLarge1, fontSizeLarge2 } from "_com/form/rich-text-constants"
import { ERROR_IMG } from '_lib/constants/global'
import markdownToHtml from './MarkdownToHtml';
import { isValidURL } from './purify';

// function handleRichTextImg (text) {
//   let imgReg = /^(https|http):\/\/[a-zA-Z0-9]+\.(max-c|maxjia)\.com/
//   return text.replace(/(<img[^>]+src=")([^"]*)("[^>]*>)/g, function(match, p1, p2, p3) {
//     if (imgReg.test(p2)) {
//       let formatSrc = formatWebplImg(p2)
//       return p1 + formatSrc + p3;
//     } else {
//       return match;
//     }
//   });
// }
function convertMarkdownImagesToText(markdown) {
  // 使用正则表达式匹配 Markdown 图片语法 ![alt-text](url)
  const imageRegex = /!\[([^\]]*)\]\(([^)]+)\)/g;

  // 使用 replace 方法将匹配到的图片替换为 alt-text
  return markdown.replace(imageRegex, (match, altText, url) => {
    return altText; // 只保留 alt-text
  });
}

export function processMarkdown(message) {
  let type = message.msg_type
  if (message.is_revoke) {
    return `此消息已被@${calcUserName(message.revoker_user)}删除`
  } if ([IM_MSG_TYPE.teamCard, IM_MSG_TYPE.teamCardV2].includes(type)) {
    return '<span>[组队卡片]</span>'
  } else if (type == IM_MSG_TYPE.teamInvite) {
    return '<span>[开黑邀约]</span>'
  } else if (([IM_MSG_TYPE.html, IM_MSG_TYPE.markdown, IM_MSG_TYPE.pure_text, IM_MSG_TYPE.AtOrChannel, 0].includes(type) && !(message.msg && message.msg.startsWith && message.msg.startsWith('<img'))) || (message.msg_type === IM_MSG_TYPE.textAndImg && message.msg)) {
    let html_text = message.msg || ''
    let imgReg = /<img[\s\S]*?(?:>|\/>)/gi;
    if (imgReg.test(html_text)) {
      html_text = html_text.replace(imgReg, (img_str) => {
        if (img_str.indexOf('data-emoji') === -1) {
          return '[图片]'
        }
        return img_str
      })
    }
    return markdownToHtml(html_text)
  } else if (type === IM_MSG_TYPE.img || (type === IM_MSG_TYPE.textAndImg && message.img)) {
    return '<span>[图片消息]</span>'
  } else if (type == IM_MSG_TYPE.sticker) {
    return '<span>[表情]</span>'
  } else if (type == IM_MSG_TYPE.channelAnc) {
    return '<span>[频道公告]</span>'
  } else if (type == IM_MSG_TYPE.uploadFile) {
    return '<span>[文件]</span>'
  } else if ([IM_MSG_TYPE.post, IM_MSG_TYPE.unknownPost].includes(type)) {
    return '<span>[帖子详情]</span>'
  } else if (type == IM_MSG_TYPE.postComment) {
    return '<span>[评论详情]</span>'
  } else if (type == IM_MSG_TYPE.customCard) {
    return '<span>[卡片消息]</span>'
  } else if ([IM_MSG_TYPE.vote, IM_MSG_TYPE.voteAnc].includes(type)) {
    return '<span>[投票]</span>'
  } else if (type == IM_MSG_TYPE.fight) { 
    return '<span>[开黑名片]</span>'
  } else if (type == IM_MSG_TYPE.miniProgram) { 
    return `<span>${message.mini_pro?.name || '小程序'}</span>`
  } else if (type == IM_MSG_TYPE.miniProDetail) { 
    if(message.msg) {
      let msg_content = JSON.parse(message.msg)
      return `<span>[${getMiniproCardName(msg_content.mini_pro_id)}卡片]</span>`
    }
    else return `<span>[存档卡片]</span>`
  } else if (type == IM_MSG_TYPE.feedbackCard) { 
    return `<span>[反馈消息]</span>`
  }
  return '<span>[未知消息]</span>'
}

function getMiniproCardName(mini_pro_id) {
  switch(mini_pro_id) {
    case 'face_shape':
      return '捏脸'
    default: 
      return '存档'
  }
}

export function turndown(str, cb) {
  str = handleH23ToH12(str)
  // html转为Markdown
  let at_list = []
  let role_list = []
  let mention_channel = []
  let emoji_info = null
  const turndownService = new TurndownService({
    headingStyle: 'atx'
  });

  const originalEscape = TurndownService.prototype.escape
  TurndownService.prototype.escape = function (string) {
    // 匹配所有的 url，并对非 url 的部分做转义处理
    const regex = /https?:\/\/[a-zA-Z0-9-._~:/?#@!$&'()*+,;=%]+/g
    let lastIndex = 0
    let escaped = ''
    let m
    do {
      m = regex.exec(string)
      const index = m ? m.index : string.length
      if (index > lastIndex) { // url 不在字符串尾部
        escaped += escape(string.slice(lastIndex, index))
      }

      if (m) {
        escaped += m[0]
      }

      lastIndex = regex.lastIndex
    } while (m)
    return escaped

    function escape(string) {
      string = originalEscape(string);
      string = string.replace(/</g, '&lt;');
      return string;
    }
  };

  turndownService.addRule('lineBreak', {
    filter: 'br',
    replacement: function (content, node, options) {
      return '<br>'
    },
  });
  // 特殊处理表情，带上表情的类型（small, medium）
  turndownService.addRule('image', {
    filter: 'img',
    replacement: function (content, node) {
      let alt = node.alt || '';
      let imageSrc = ''
      if (node.getAttribute('data-emoji') == '1') {
        try {
          if (alt && alt.startsWith('[custom') && alt.endsWith(']')) {
            emoji_info = emoji_info || {}
            const emojiName = alt.slice(1, -1)
            const src = node.getAttribute('src').split('?')[0]
            const endPath = src.split('/').pop()
            const paths = endPath.split('.')
            emoji_info[emojiName] = {
              path: paths[0],
              ext: paths[1],
              name: emojiName,
              room_id: emojiName.slice(6).split('_')[0]
            }
          }
        } catch (e) {}
        return alt
      } else if (node.getAttribute('data-img-key') && node.getAttribute('data-img-src')) {
        imageSrc = node.getAttribute('data-img-src')
      } else {
        imageSrc = node.getAttribute('src') || '';
      }
      imageSrc = imageSrc.split('?')[0]
      if(!isValidURL(imageSrc)) return ''
      const classList = Array.from(node.classList).filter(c => c !== 'hb-editor-chat-img')
      let classListStr = classList.join(' ');
      classListStr = classListStr.trim()
      if (classListStr) {
        return `![${alt}](${imageSrc} "${classListStr}")`
      }
      return `![${alt}](${imageSrc})`
    }
  });
  turndownService.keep(function (node) {
    let fontSizeStyled = [fontSizeLarge1, fontSizeLarge2].includes(node.style.fontSize)
    return (
      node.nodeName === 'SPAN' &&
      fontSizeStyled
    )
  })
  turndownService.addRule('a', {
    filter: 'a',
    replacement: function (content, node) {
      const classList = Array.from(node.classList)
      if (classList.includes('hb-editor-chat-user')) {
        let user_id = node.getAttribute('data-remind-user-id')
        content = convertMarkdownImagesToText(content)
        if (user_id) {
          // 0是在线成员, -9999是群聊的全体成员
          if (/^\d+$/.test(user_id) && `${user_id}`.length >= 10 || user_id == '0' || /^-9999$/.test(user_id)) {
            role_list.push({
              role_id: user_id,
              name: content.replace('@', ''),
            })
          } else {
            let name = content.replace('@', '')
            at_list.push({
              user_id: user_id,
              nickname: name,
              room_nickname: name, //此处的name已是三合一的结果，直接设置room_nickname最高优先级
            })
          }
          return (`@{id:${user_id}}`).replaceAll(/"/g, "\"")
        } else {
          return content
        }
      } else if (classList.includes('hb-editor-chat-channel')) {
        let channel_id = node.getAttribute('data-remind-channel-id') || ''
        mention_channel.push({
          channel_id,
          channel_name: content.replace('#', ''),
        })
        let channel_at = (`#{id:${channel_id}}`).replaceAll(/"/g, "\"")
        return channel_at
      } else {
        let href = node.getAttribute('href')
        if (!/^https?:\/\//i.test(href)) {
          href = 'http://' + href;
        }
        if(isValidURL(href)){
          return `[${content}](${href})`
        }
        return ``
      }
    }
  });
  
  // 添加下划线支持
  turndownService.addRule('underline', {
    filter: 'u',
    replacement: function (content, node) {
      return `<u>${content}</u>`
    }
  });

  // 替换~，防止~~被解析成中划线样式
  turndownService.addRule('replace_wave', {
    filter: function (node) {
      return /~.*~/.test(node.innerText)
    },
    replacement: function (content) {
      return content.replace(/~/g, '\\~')
    }
  })
  const htmlContent = cleanHtmlContent(str)
  let markdownContent = turndownService.turndown(htmlContent); // 将 HTML 转换为 Markdown  
  cb && cb(markdownContent, at_list, role_list, mention_channel, emoji_info)
  return markdownContent
}

// 预处理函数，替换空p标签为换行，但是不保留首位的多余换行
function cleanHtmlContent(html) {
  let content = html.replace(/<p>\s*<\/p>/g, '<br/>')
  content = content.trim() // 去掉首尾的空白字符
  content = content.replace(/^(<br\/>\s*)+/, '')  // 去除开头的 <br/>
  content = content.replace(/(\s*<br\/>)+$/, '')  // 去除结尾的 <br/>

  return content
}

export function htmlToHbEditorHtml (html) {
  let parser = new DOMParser()
  let doc = parser.parseFromString(html, 'text/html')
  let atUsers = doc.querySelectorAll('at.at')
  atUsers.forEach(at => {
    let a = document.createElement('a')
    const is_grident = at.classList.contains('gradient')
    a.className = 'hb-editor-chat-user' + (is_grident ? ' gradient' : '')
    a.setAttribute('style', at.style.cssText)
    a.contenteditable = 'false'
    a.draggable = 'true'
    a.setAttribute('data-remind-user-id', at.getAttribute('user_id') || at.getAttribute('roles_id'))
    a.innerHTML = `${at.innerHTML} `
    at.parentNode.replaceChild(a, at)
  })

  const atChannels = doc.querySelectorAll('at.channel-mentioned')
  atChannels.forEach(at => {
    let a = document.createElement('a')
    a.className = 'hb-editor-chat-channel'
    a.setAttribute('data-remind-channel-id', at.getAttribute('channel_id'))
    a.innerHTML = `${at.innerHTML} `
    at.parentNode.replaceChild(a, at)
  })

  // chat-img-html转成img
  const imgBlocks = doc.querySelectorAll('.cpt-chat-img.img-info-block')
  imgBlocks.forEach(imgBlock => {
    let img = document.createElement('img')
    img.className = 'hb-editor-chat-img'
    img.src = imgBlock.querySelector('.img-dom').src
    img.alt = 'image'
    img.setAttribute('data-img-src', imgBlock.querySelector('.img-dom').src)
    // img.setAttribute('data-img-key', imgBlock.querySelector('.img-dom').src)
    img.contenteditable = 'false'
    img.draggable = 'true'
    imgBlock.parentNode.replaceChild(img, imgBlock)
  })


  return doc.body.innerHTML
}

export function handleH23ToH12 (str) {
  // 将所有的h2,h3转为h1,h2
  let h2Reg = /<h2.*?>(.*?)<\/h2>/g
  let h3Reg = /<h3.*?>(.*?)<\/h3>/g
  let h2Arr = str.match(h2Reg)
  let h3Arr = str.match(h3Reg)
  if (h2Arr) {
    h2Arr.forEach((h2) => {
      let h2Content = h2.match(/<h2.*?>(.*?)<\/h2>/)[1]
      str = str.replace(h2, `<h1>${h2Content}</h1>`)
    })
  }
  if (h3Arr) {
    h3Arr.forEach((h3) => {
      let h3Content = h3.match(/<h3.*?>(.*?)<\/h3>/)[1]
      str = str.replace(h3, `<h2>${h3Content}</h2>`)
    })
  }
  return str
}

export function handleH12ToH23 (str) {
  // 将所有的h1,h2转为h2,h3
  let h1Reg = /<h1.*?>(.*?)<\/h1>/g
  let h2Reg = /<h2.*?>(.*?)<\/h2>/g
  let h1Arr = str.match(h1Reg)
  let h2Arr = str.match(h2Reg)
  if (h1Arr) {
    h1Arr.forEach((h1) => {
      let h1Content = h1.match(/<h1.*?>(.*?)<\/h1>/)[1]
      str = str.replace(h1, `<h2>${h1Content}</h2>`)
    })
  }
  if (h2Arr) {
    h2Arr.forEach((h2) => {
      let h2Content = h2.match(/<h2.*?>(.*?)<\/h2>/)[1]
      str = str.replace(h2, `<h3>${h2Content}</h3>`)
    })
  }
  return str

}
